import {
  CreateVersionModel,
  DuplicateVersionModel,
  List,
  UpdateVersionModel,
  VersionModel,
} from '@partful/instructions-domain-models';
import { BaseService } from '@partful/shared/api/baseService';

export class VersionsService extends BaseService {
  async create(account: string, instructionId: string, createArgs: CreateVersionModel): Promise<VersionModel> {
    const res = await this.client.post(`/instructions/${instructionId}/versions`, createArgs, {
      params: { account },
    });
    return res.data;
  }

  async list(account: string, instructionId: string, args: { nextToken?: string }): Promise<List<VersionModel>> {
    const res = await this.client.get<List<VersionModel>>(`/instructions/${instructionId}/versions`, {
      params: { account, ...args },
    });
    return res.data;
  }

  async get(account: string, instructionId: string, versionId: string): Promise<VersionModel> {
    const res = await this.client.get(`/instructions/${instructionId}/versions/${versionId}`, { params: { account } });
    return res.data;
  }

  async update(
    account: string,
    instructionId: string,
    versionId: string,
    updateArgs: UpdateVersionModel
  ): Promise<VersionModel> {
    const res = await this.client.patch(`/instructions/${instructionId}/versions/${versionId}`, updateArgs, {
      params: { account },
    });
    return res.data;
  }

  async duplicate(
    account: string,
    instructionId: string,
    versionId: string,
    duplicateArgs: DuplicateVersionModel
  ): Promise<VersionModel> {
    const res = await this.client.post(`/instructions/${instructionId}/versions/${versionId}`, duplicateArgs, {
      params: { account },
    });
    return res.data;
  }
}
